module.exports = __webpack_public_path__ + "static/media/8secondz.9388d614.png";